import { useMemo } from "react"

import ClickableNameList from "#blocks/ClickableNameList"
import { type Uuid } from "#customTypes/globalTypes"
import { useGetSomeStudents } from "#hooks/jotai/useGetStudents"
import { formatStudents } from "#utils/textFormatters"

const AddClassStudentList = ({
  onStudentClick,
  studentIds,
}: {
  onStudentClick: (studentId: Uuid) => void
  studentIds: Uuid[]
}) => {
  const studentsFromDb = useGetSomeStudents(studentIds)
  const studentsForDisplay = useMemo(() => {
    return formatStudents(studentsFromDb)
  }, [studentsFromDb])

  return (
    <ClickableNameList
      namesForDisplay={studentsForDisplay}
      onClick={onStudentClick}
      columns={3}
    />
  )
}

export default AddClassStudentList
